import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, switchMap, take } from 'rxjs';

import { FeatureFlagFacade, FeatureFlagKeys } from '@ninety/platform/state';

import { RawSearchResponse, SearchRequestParams, SearchResponse, parseSearchResponse } from './global-search-api.model';

export const SEARCH_API_URL = '/api/internal/search/v1/search';
export const EKS_SEARCH_API_URL = '/eks/search-service/v1/search';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApiService {
  private readonly http = inject(HttpClient);
  private readonly featureFlags = inject(FeatureFlagFacade);

  search(params: SearchRequestParams): Observable<SearchResponse> {
    let httpParams = new HttpParams()
      .set('query', params.query)
      .set('archived', params.archived)
      .set('deleted', params.deleted);

    if (params.pageIndex != null) {
      httpParams = httpParams.set('pageIndex', params.pageIndex);
    }
    if (params.pageSize != null) {
      httpParams = httpParams.set('pageSize', params.pageSize);
    }

    return this.featureFlags.getFlag(FeatureFlagKeys.deliveryEksMigrationSearchService).pipe(
      take(1),
      switchMap(useEksSearchService =>
        this.http
          .get<RawSearchResponse>(useEksSearchService ? EKS_SEARCH_API_URL : SEARCH_API_URL, { params: httpParams })
          .pipe(map(parseSearchResponse))
      )
    );
  }
}
